import React from 'react';
import {Box} from '@mui/material';
import {GetServerSidePropsContext} from 'next';
import ErrorPage from 'next/error';
import Content404 from '~/components/wrapper/organisms/content-404';
import {handleConvertToLocaleContentful} from '~/utils';
import {BlockRenderer} from '~/components/renderer/block-renderer';
import {getGloablByType} from '~/utils/global-operations';
import {GLOBAL_TYPE} from '~/constants/content-map-type';
import {getPageData} from '../[[...slug]]/index.page';

type PropsPage404 = {
  data: any;
  content404: any;
  locale: string;
};
const Page404: React.FC<PropsPage404> = ({data, content404}) => {
  const page = data?.pageCollection?.items[0];
  if (!page) {
    return <ErrorPage statusCode={404} />;
  }
  // const subscribe = {
  //   __typename: 'SubscribePopup',
  // };

  return (
    <Box
      sx={{
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        flex: '1',
      }}
    >
      <Content404 content={content404} />
      {/* <BlockRenderer block={[subscribe]} /> */}
    </Box>
  );
};

export const getStaticProps = async (ctx: GetServerSidePropsContext) => {
  const preview = !!(process && process.env && process.env.NEXT_PUBLIC_PREVIEW);

  const promises: [ReturnType<typeof getPageData>, ReturnType<typeof getGloablByType>] = [
    getPageData({slug: '404', preview}, ctx),
    getGloablByType(handleConvertToLocaleContentful(ctx.locale as string), GLOBAL_TYPE.content404),
  ];

  const [pageData, content404] = await Promise.all(promises);
  const {data} = pageData;
  return {
    props: {
      data,
      content404,
      locale: ctx.locale,
    },
    revalidate: 60 * 5,
  };
};

export default Page404;
